module.exports = __webpack_public_path__ + "ac42c264f50f0a695d545e5ae8982ea0.svg";